<template>
  <el-main>
    <app-search
      :search="search"
      @onSearch="handleSearch"
      @onSelect="handleSelect"
      @onSubmit="handleSubmit"
      @onClear="handleClear"
    />
    <component :is="getComponentByRole" />
  </el-main>
</template>

<script>
/*
  home component wrapper
  use i18n locale
  see http://kazupon.github.io/vue-i18n/started.html for details
*/

// components
import AppSearch from "../../../components/AppSearch";
import OperatorFeedList from "./feeds/OperatorFeedList";
import ManagerFeedList from "./feeds/ManagerFeedList";
import AdminFeedList from "./feeds/AdminFeedList";

// vuex
import { mapGetters } from "vuex";

// actions
import { SEARCH, SET_SEARCH } from "../../../store/actions/feeds";

export default {
  name: 'PageContent',
  data() {
    return {
      feedPostfix: "FeedList",
      search: {
        selectItems: this.$t('search.items'),
        select: "byName",
        input: ""
      }
    };
  },
  computed: {
    ...mapGetters([
      "userRole",
      "hasSearch",
      "searchString"
    ]),
    getComponentByRole() {
      return `${this.userRole[0].toUpperCase() + this.userRole.slice(1)}${this.feedPostfix}`;
    },
  },
  methods: {
    handleSearch(value) {
      this.search.input = value;
    },
    handleSelect(value) {
      this.search.select = value;
    },
    handleClear() {
      this.$store.dispatch(SET_SEARCH, false);
      this.search.input = "";
      this.search.select = "byName";
    },
    handleSubmit() {
      this.$store.dispatch(SEARCH, this.search);
      this.$store.dispatch(SET_SEARCH, true);
    }
  },
  mounted() {
    this.search.input = this.searchString;
  },
  components: {
    AppSearch,
    OperatorFeedList,
    ManagerFeedList,
    AdminFeedList
  }
}
</script>
